import Tone from 'tone';
import {A_RATE, K_RATE} from 'constants/automation-rates.js';
// part of a macro: containing a parameter, min, and max

export default class SubMacro  {
    constructor(parameter, min, max, macro) {
        this.macro = macro;
        this.parameter = parameter;
        this._min = min;
        this._max = max;

        // Tone.Scale doesn't work for negative values, unfortunately
        // so we need to add up by the minimum value
        let adjust = Math.abs(Math.min(this._min, this._max));
        this.scaler = new Tone.Scale(this._min + adjust, this._max + adjust);
        this.subtract = new Tone.Subtract(this._min < 0 || this._max < 0 ? 0 : adjust);
        this.scaler.connect(this.subtract);

        if (this.parameter.audioParams) {
            for (let i in this.parameter.audioParams) {
                let input = this.parameter.audioParams[i].input ||
                    this.parameter.audioParams[i];
                if (Array.isArray(input)) {
                    input = input[0];
                }
                this.subtract.connect(input);
            }
            // connect scaler to parameter
        } else if (this.parameter.audioParam) {
            this.subtract.connect(this.parameter.audioParam);
        }
        this.parameter.automationRate = A_RATE;
    }

    withSignal(signal) {
        signal.connect(this.scaler);
    }

    dispose() {
        if (this._disposed) {
            return;
        }
        this.scaler.disconnect();
        this.scaler.dispose();
        this.subtract.disconnect();
        this.subtract.dispose();
        this._disposed = true;
    }

    normalizeValue(value) {
        return this.min + (this.max - this.min)*value;
    }

    updateRedux(value) {
        value = this.normalizeValue(value);
        this.parameter.set(value, undefined, true, undefined, true);
        return {
            id: this.parameter.id,
            value: value
        };
    }

    set min(min) {
        this._min = min;
        let adjust = Math.abs(Math.min(this._min, this._max));
        this.scaler.min = min + adjust;
        this.scaler.max = this._max + adjust;
        this.subtract.value = this._min < 0 || this._max < 0 ? 0 : adjust;
    }

    set max(max) {
        this._max = max;
        let adjust = Math.abs(Math.min(this._min, this._max));
        this.scaler.max = max + adjust;
        this.scaler.min = this._min + adjust;
        this.subtract.value = this._min < 0 || this._max < 0 ? 0 : adjust;
    }

    get min() {
        return this._min;
    }

    get max() {
        return this._max;
    }

    getJson() {
        return {
            parameter: this.parameter.id,
            min: this.min,
            max: this.max
        };
    }
}

